import React, { PureComponent } from 'react';
import { string } from 'prop-types';
import { Link } from 'react-router-dom';
import { createMarkup } from '../../utils/utils';

class FaqSearchResultsItem extends PureComponent {
  static propTypes = {
    title: string.isRequired,
    path: string.isRequired,
    preview: string.isRequired,
  };

  render() {
    const { title, path, preview } = this.props;

    return (
      <div className="faq-search-result-item">
        <h3>
          <Link to={'/' + path}>{title}</Link>
        </h3>
        <div className="result-item-preview" dangerouslySetInnerHTML={createMarkup(preview)} />
      </div>
    );
  }
}

export default FaqSearchResultsItem;
